import { getApiBaseUrl, SALON_API_PREFIX } from './apiConfig';
import { getSalonComparePreviousFlag } from './salonFaceSession';
import { fetchWithTimeout } from './fetchWithTimeout';

/**
 * Fetch the most recent previous skin analysis for the same contact and same organization.
 * Identity and org come from the authenticated current session — not client overrides.
 * @param {string} sessionId - Current session_id (skin_reference)
 * @param {string} [appSessionToken] - Session token from URL (for org scoping)
 * @returns {Promise<{ success: boolean, previous: null | object }>}
 */
export async function getPreviousSkinAnalysis(sessionId, appSessionToken) {
  if (!sessionId || typeof sessionId !== 'string') {
    return { success: true, previous: null };
  }
  const base = getApiBaseUrl();
  if (!base) {
    return { success: true, previous: null };
  }
  const params = new URLSearchParams();
  params.set('session_id', sessionId);
  if (appSessionToken && String(appSessionToken).trim()) {
    params.set('app_session_token', String(appSessionToken).trim());
  }
  if (getSalonComparePreviousFlag()) {
    params.set('compare_previous', '1');
  }
  const url = `${base.replace(/\/$/, '')}${SALON_API_PREFIX}/previous-skin-analysis?${params.toString()}`;
  const res = await fetchWithTimeout(url, { method: 'GET', headers: { Accept: 'application/json' }, timeoutMs: 20000 });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    return { success: false, previous: null };
  }
  return { success: Boolean(data.success), previous: data.previous || null };
}
